"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Weight = exports.WeightUnitShortLabels = exports.WeightUnitLabels = exports.WeightUnit = exports.WeightUnits = void 0;
const typebox_1 = require("@sinclair/typebox");
// SHORT_TON is what is used in the US it is equal to 2,000 lbs
exports.WeightUnits = ['SHORT_TONS', 'POUNDS'];
exports.WeightUnit = typebox_1.Type.Union(exports.WeightUnits.map((type) => typebox_1.Type.Literal(type)));
exports.WeightUnitLabels = {
    SHORT_TONS: 'Tons',
    POUNDS: 'Pounds',
};
exports.WeightUnitShortLabels = {
    SHORT_TONS: 'T',
    POUNDS: 'lbs',
};
exports.Weight = typebox_1.Type.Object({
    value: typebox_1.Type.Number(),
    unit: exports.WeightUnit,
});
//# sourceMappingURL=weight.js.map